module.exports = __webpack_public_path__ + "static/media/logo_3divi_black.d30ca0c0.svg";